import EventNoteIcon from '@mui/icons-material/EventNote';

export const authenticatedMenuItems = [
  { title: 'Actividades', Icon: EventNoteIcon, to: '/activities' },
  { title: 'Todos', Icon: EventNoteIcon, to: '/todos' },
];

export const menuItems = [
  { title: 'Actividades', Icon: EventNoteIcon, to: '/activities' },
];
